var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("compare-sect-v2", { attrs: { background: "background-img" } }),
      _vm._v(" "),
      _c("how-worsks", { attrs: { background: "background-grey" } }),
      _vm._v(" "),
      _c("content-part"),
      _vm._v(" "),
      _c("city-part", { attrs: { background: "background-img" } }),
      _vm._v(" "),
      _c("title-part"),
      _vm._v(" "),
      _c("title-part", { attrs: { background: "background-grey" } }),
      _vm._v(" "),
      _c("content-nd-compare"),
      _vm._v(" "),
      _c("faq-new"),
      _vm._v(" "),
      _c("other-service"),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "to-app-btn" }, [
      _c("button", { staticClass: "back-btn" }, [
        _c("img", {
          attrs: { src: "/img/icon/arrow-down-white.svg", alt: "" }
        }),
        _vm._v(" Back to application")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }